import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";

/**
 * Plugins
 * 管理滤境，如 cssStyle, svg path
 */
import { dataToArray } from '../utils';

var Plugin = /*#__PURE__*/_createClass(function Plugin() {
  var _this = this;

  _classCallCheck(this, Plugin);

  this.push = function (plugins) {
    dataToArray(plugins).forEach(function (item) {
      _this[item.className] = item;
    });
  };

  this.register = this.push;
});

export default new Plugin();
export { Plugin };